import {useMemo} from "react";
import {useSelector} from "react-redux";

export const useDateTimeParser = () => {
    const {restaurant} = useSelector(state => state.dashboard.view);
    const timeZoneId = restaurant?.value?.settings?.timeZoneId;

    const normalizeDate = (value) => {
        if (!value) return null;

        const date = value instanceof Date ? value : new Date(value);
        return Number.isNaN(date.getTime()) ? null : date;
    };

    const safeTimeZone = useMemo(() => {
        try {
            Intl.DateTimeFormat(undefined, {timeZone: timeZoneId});
            return timeZoneId;
        } catch {
            return 'UTC';
        }
    }, [timeZoneId]);

    const parseDate = (value) => {
        const date = normalizeDate(value);
        if (!date) return '-';

        return date.toLocaleDateString(undefined, {
            timeZone: safeTimeZone
        });
    };

    const parseTime = (value) => {
        const date = normalizeDate(value);
        if (!date) return '-';

        return date.toLocaleTimeString(undefined, {
            hour: '2-digit',
            minute: '2-digit',
            hour12: false,
            timeZone: safeTimeZone
        });
    };

    return {
        parseDate,
        parseTime,
        timeZoneId: safeTimeZone
    };
};